// Map
import {createMap, fitMap} from './map';
import {addIncidentsIndexLayer} from './layers/incidents';
import {addPerimetersIndexLayer} from './layers/perimeters';
import {addEvacuationZonesIndexLayer} from './layers/evacuation-zones';
import {toggleLegendItems} from './layers/legend';

// Text
import {createFireLists} from './index-info/list';
import {writeRobotext} from './index-info/robotext'

// Other
import {addMethodologyEvents} from './index-info/methodology';
import {cdnUrl, mapboxAccessToken} from './resources/constants';
import {setLastUpdatedTimeSince, setCopyrightYear, decodeTopojsonFeatures} from './resources/utils';
import {zoomToQueryParamsIndex} from './methods/zoom'

mapboxgl.accessToken = mapboxAccessToken;

const bootMap = (topodata) => {
  // Create the map
  window.fireMap = createMap('mapbox://styles/latimes/ck1b57qqj080j1cpe1xhj87fm');
  // Write the robotext
  writeRobotext(topodata.fire_list);

  // Set timestamps
  setLastUpdatedTimeSince(topodata.metadata.last_archived);

  // Parse all the data
  window.fireData = {
    'perimeters': decodeTopojsonFeatures(topodata, 'perimeters'),
    'incidents': decodeTopojsonFeatures(topodata, 'incidents'),
    'evacuationZones': decodeTopojsonFeatures(topodata, 'evacuation_zones'),
    'fireList': topodata.fire_list,
    'metadata': {
      'lastArchived': topodata.metadata.last_archived
    }
  };``
  console.log(fireData)

  // Cut out the Bobcat fire in Montana for now as a hack
  window.fireData.incidents.features = window.fireData.incidents.features.filter(f => {
    return (f.properties.slug == 'bobcat' && f.properties.state == 'MT') ? false : true
  });
  window.fireData.fireList = window.fireData.fireList.filter(d => {
    return (d.slug == 'bobcat' && d.state == 'MT') ? false : true
  })
  window.fireData.perimeters.features = window.fireData.perimeters.features.filter(d => {
    return (d.properties.slug == 'bobcat') ? false : true
  });

  //cut out srf lightning cause now it's six rivers
  window.fireData.incidents.features = window.fireData.incidents.features.filter(d => {
    return (d.properties.slug == '2022-srf-lightning-complex') ? false : true
  });
  window.fireData.fireList = window.fireData.fireList.filter(d => {
    return (d.slug == '2022-srf-lightning-complex') ? false : true
  })
  window.fireData.perimeters.features = window.fireData.perimeters.features.filter(d => {
    return (d.properties.slug == '2022-srf-lightning-complex') ? false : true
  });

  // Add fire list and cards
  createFireLists();

  // Load layers
  window.fireMap.on('load', function() {
    // Add layers
    addPerimetersIndexLayer();
    addIncidentsIndexLayer();
    addEvacuationZonesIndexLayer();
    // Refit the map
    fitMap();
    zoomToQueryParamsIndex(window.location.search.replace('?', ''));
    toggleLegendItems();
  });
};

// Fire it up
fetch(cdnUrl)
  .then(r => r.json())
  .then(bootMap);

// Add event handlers
addMethodologyEvents();

// Set the copyright to today's date
setCopyrightYear();
